"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionUtils = void 0;
class CollectionUtils {
    static isNullOrEmpty(collection) {
        return !collection || collection.length === 0;
    }
}
exports.CollectionUtils = CollectionUtils;
//# sourceMappingURL=CollectionUtils.js.map